// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_OOn","cls2":"News-cls2_wV6 News-cls1_OOn"};